import React, { useEffect, useState } from "react";
import { ArrowLeft, Eye, EyeSlash } from "iconsax-react";

import { Link, useNavigate } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import { enqueueSnackbar } from "notistack";
import { ClipLoader } from "react-spinners";
import { LSSB } from "../utils/LSSB_live";

const Signup = () => {
  const navigate = useNavigate();

  const [lassra, setLassra] = useState("");
  const [idType, setIdType] = useState("LASRRA");
  const [idNumber, setIdNumber] = useState("");
  const [stage, setStage] = useState(0);
  const [lassraData, setLassraData] = useState([]);
  const [idPhoto, setIdPhoto] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [password, setPassword] = useState("");
  const [phone2, setPhone2] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [image, setImage] = useState("");
  const [consentGiven, setConsentGiven] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [imageErrorMessage, setImageErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  const toggle = () => {
    setOpen(!open);
  };
  const toggle1 = () => {
    setOpen1(!open1);
  };

  const [formValue, setFormValue] = useState({
    idNumber: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    middleName: "",
    email: "",
    phone: "",
    lastName: "",
    fullName: "",
    dob: "",
    gender: "",
    idType: "",
    address: "",
    division: "",
    userName: "",
    Bank_Name: "",
    Account_Name: "",
    Account_Number: "",
  });

  let userData = sessionStorage.getItem("lssbAdminData");
  userData = JSON.parse(userData);

  const getLassraUser = async (e) => {
    e.preventDefault();
    if (idType !== "LASRRA") {
      setStage(1);
      setFormValue({ ...formValue, email: idNumber });
      return;
    }
    setIsLoading(true);

    try {
      let res = await LSSB.make_API_call({
        $k: "",
        _endpoint: "get_lasrra_data",
        isLASRRA: true,
        lassra_id: idNumber,
      });
      setLassraData(res?.data?.data);
      setLassra(idNumber);
      setFormValue({
        firstName: res?.data?.data.firstname,
        lastName: res?.data?.data.lastname,
        dob: res?.data?.data.dob,
        gender: res?.data?.data.sex === "M" ? "Male" : "Female",
        email: res?.data?.data.email,
        middleName: res?.data?.data.middleName,
        phone: res?.data?.data.phone_no,
        address: res?.data?.data.address,
        fullName: res?.data?.data?.fullname,
      });
      if (res?.status === 200) {
        setStage(1);
        setIsLoading(false);

        enqueueSnackbar("LASRRA details fetched successfully", {
          variant: "success",
        });
      } else {
        enqueueSnackbar(res?.error?.msg, { variant: "error" });

        setIsLoading(false);
      }

      // console.log("response", res);
    } catch (err) {
      console.error("Error:", err);
      enqueueSnackbar(err?.error?.msg, { variant: "error" });
    }
  };

  const signUpUser = async (e) => {
    e.preventDefault();
    if (formValue?.userName.length < 6) {
      enqueueSnackbar("Username must be 6 digit and above", {
        variant: "warning",
      });
      return;
    }

    if (isImageLoading) {
      enqueueSnackbar("Please wait. Image still Uploading", {
        variant: "warning",
      });
      return;
    }
    if (!image) {
      enqueueSnackbar("Selfie is required", { variant: "error" });
      return;
    }

    setIsLoading(true);
    try {
      let res = await LSSB.make_API_call({
        _endpoint: "create_user",
        _fields: {
          email: formValue?.email, // **required
          fullname: inputDisabled
            ? formValue?.fullName
            : formValue?.firstName + " " + formValue?.lastName, // **required
          middleName: formValue?.middleName, // **required
          lastname: formValue?.lastName, // **required
          firstname: formValue?.firstName, // **required
          username: formValue.userName,
          password: password, // **required
          // division: 'EPE',   // **required
          confirm_password: confirmPassword, // **required
          phone_no: formValue?.phone,
          nin: idType === "NIN" ? idNumber : "",
          lassra: lassra,
          dob: formValue?.dob,
          sex: formValue?.gender,
          address: formValue?.address,
          division: formValue?.division,
          phone2: phone2,
          image: image, // **required
          id_image: idPhoto,
          // bank_name: formValue?.Bank_Name,
          // account_name: formValue?.Account_Name,
          // account_number: formValue?.Account_Number,
        },
        _academic_criteria: {
          indigeneship_status: "Unverified",
          studentship_status: "Unverified",
        },
      });
      if (res?.success === true) {
        enqueueSnackbar(res?.data.msg, { variant: "success" });
        navigate("/otp", {
          state: { email: formValue.email, username: formValue.userName },
        });
        setIsLoading(false);
      } else {
        enqueueSnackbar(res?.error?.msg, { variant: "error" });
        setIsLoading(false);
      }
    } catch (err) {
      enqueueSnackbar(err?.error?.msg, { variant: "error" });
      setIsLoading(false);
    }
  };

  function handlePassword(event) {
    let new_pass = event.target.value;
    setPassword(new_pass);

    // regular expressions to validate password
    var lowerCase = /[a-z]/g;
    var upperCase = /[A-Z]/g;
    var numbers = /[0-9]/g;
    var specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    if (!new_pass.match(upperCase)) {
      setErrorMessage("Password should contains Uppercase letters!");
    } else if (!new_pass.match(lowerCase)) {
      setErrorMessage("Password should contain lowercase letters!");
    } else if (!new_pass.match(numbers)) {
      setErrorMessage("Password should contains numbers also!");
    } else if (!new_pass.match(specialCharRegExp)) {
      setErrorMessage("Password should contains special character e.g *@#!% !");
    } else if (new_pass.length < 6) {
      setErrorMessage("Password length should be more than 6.");
    } else {
      setErrorMessage("Password is strong!");
    }
    // for confirm password
  }
  const handleConfirmPassword = (event) => {
    let confirm_pass = event.target.value;
    setConfirmPassword(confirm_pass);
    if (confirm_pass !== password) {
      setConfirmPasswordError("Password does not match!");
    } else {
      setConfirmPasswordError("Password match!");
    }
  };

  const file_uploader = async function (params) {
    const file = params.files[0];
    const maxSize = 200 * 1024; // 2MB in bytes

    if (file && file.size > maxSize) {
      setImageError(true);
      setImageErrorMessage("File size must be less than 200kb or below");
      params.value = ""; // Reset file input
      return;
    }
    setIsImageLoading(true);
    setImageError(false);

    let ff = new FormData();
    const input_field = params;
    let file_name = input_field.attributes.name
      ? input_field.attributes.name.value
      : "file_name";
    ff.append(file_name, input_field.files[0]);

    ff.append("upload_key", file_name);
    ff.append("upload_file_name", input_field.files[0].name);

    let res_file_upload = await LSSB.make_API_call({
      _endpoint: "file_uploads",
      contentType: "multipart/form-data",
      data: ff,
    });

    // console.log(" File upload  :: --> ", "res_users", "res", res_file_upload);
    if (res_file_upload?.status === 200) {
      setImage(res_file_upload?.data?.files[0]);
      setIsImageLoading(false);
    } else {
      enqueueSnackbar("Image Genaration Failed", { variant: "error" });
      setImageError(true);
      setImageErrorMessage("Image upload failed.Kindly re-upload image");
      setIsImageLoading(false);
    }
  };

  const inputDisabled = idType === "LASRRA";
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="h-screen  w-full flex items-center ">
      <div className="h-full w-[20%] md:w-[50%] relative hidden md:block">
        {" "}
        <img
          src="./asset/homeImage.png"
          alt=""
          className="object-cover h-full w-full -z-10"
        />
      </div>
      <div className="h-full w-full md:w-[50%] bg-[#ffff] flex justify-center   overflow-scroll">
        <div className="md:hidden flex gap-[16px] items-center absolute z-10 top-[24px] left-[24px] md:top-[48px] md:left-[48px]">
          <img
            src="./asset/lssbLogo.png"
            alt="logo"
            className="h-[40px] w-[40px] md:h-[58px] md:w-[58px]"
          />
          <div>
            <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
              Lagos State
            </p>
            <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
              Scholarship Board
            </p>
          </div>
        </div>
        {stage === 0 && (
          <div className="bg-[#ffff] rounded-[16px] w-[360px] max-w-[360px] sm:w-[480px] sm:max-w-[480px] md:w-[408px] md:max-w-[409px] pt-[24px] md:pt-[32px]  pb-[24px] my-auto ">
            <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[20px] md:mb-[30px] xl:mb-[50px]">
              Sign Up
            </h2>

            <form
              onSubmit={(e) => {
                getLassraUser(e);
              }}
              className=" w-full"
            >
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Sign Up With{" "}
                </label>
                <div className=" ">
                  <select
                    type="text"
                    placeholder="Enter LASRRA ID"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    value={idType}
                    onChange={(event) => {
                      setIdType(event.target.value);
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  >
                    <option value="Email">Email</option>
                    <option value="LASRRA">LASRRA</option>
                  </select>
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter {idType} {idType === "LASRRA" ? " ID" : ""}
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder={`Enter ${idType}`}
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    value={idNumber}
                    onChange={(e) => {
                      setIdNumber(e.target.value);
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="w-full py-[14px] text-center text-white bg-[#AF8544]  flex items-center justify-center gap-2 mb-[20px] md:mb-[32px]"
              >
                <p className="text-sm font-medium leading-[20px] mr-3">
                  Continue
                </p>
                {isLoading && <ClipLoader color={"white"} size={20} />}
              </button>

              <div className="text-[14px] leading-[20px] text-[#7C8493] flex j items-center mb-[13px] ">
                <p>Already have an account? &nbsp; </p>
                <Link to="/login">
                  {" "}
                  <button className="font-medium text-[#AF8544]"> Login</button>
                </Link>
              </div>

              <p className=" text-[14px]  leading-[20px]  text-[#7C8493]">
                By clicking 'Continue', you acknowledge that you have read and
                accept the{" "}
                <Link to="/terms-and-condition">
                  {" "}
                  <span className="text-[#AF8544]">
                    Terms of Service
                  </span> and{" "}
                  <span className="text-[#AF8544]">Privacy Policy.</span>
                </Link>
              </p>
            </form>
          </div>
        )}
        {stage === 1 && (
          <div className="bg-[#ffff]  w-[360px] max-w-[360px] sm:w-[480px] sm:max-w-[480px] md:w-[408px] md:max-w-[409px] mt-[74px] md:mt-[62px]  pb-[54px] my-auto ">
            <div className="relative">
              {" "}
              <button
                onClick={() => setStage(stage - 1)}
                className="absolute left-0 top-2"
              >
                {" "}
                <ArrowLeft variant="Linear" color="#25324B" size="24" />
              </button>
              <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[10px] md:mb-[20px] ">
                Account Sign up
              </h2>
            </div>

            <ProgressBar
              completed={35}
              bgColor="#AF8544"
              baseBgColor="#A8ADB7"
              isLabelVisible={false}
              height="4px"
            />

            <form
              onSubmit={() => {
                setStage(2);
              }}
              className=" w-full mt-[20px]"
            >
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter LASRRA ID
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder={`Enter LASRRA ID`}
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required={inputDisabled}
                    autoComplete="on"
                    disabled={inputDisabled}
                    value={lassra}
                    onChange={(e) => {
                      setLassra(e.target.value);
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>
              {inputDisabled && (
                <div className="mb-[24px]">
                  <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                    Enter Full Name
                  </label>
                  <div className=" ">
                    <input
                      type="text"
                      placeholder="Enter Full Name"
                      className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                      required
                      autoComplete="on"
                      disabled={inputDisabled}
                      value={formValue?.fullName}
                      onChange={(e) => {
                        setFormValue({
                          ...formValue,
                          fullName: e.target.value,
                        });
                      }}
                      autoCapitalize="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                  </div>
                </div>
              )}
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter First Name
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="Enter First Name"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    disabled={inputDisabled}
                    name="firstname"
                    // id="email"
                    value={formValue?.firstName}
                    onChange={(e) => {
                      setFormValue({ ...formValue, firstName: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Middle Name
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="Enter middle Name"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    disabled={inputDisabled}
                    name="middlename"
                    // id="email"
                    value={formValue?.middleName}
                    onChange={(e) => {
                      setFormValue({
                        ...formValue,
                        middleName: e.target.value,
                      });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Last Name
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="Enter last name "
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    disabled={inputDisabled}
                    name="lastname"
                    // id="email"
                    value={formValue?.lastName}
                    onChange={(e) => {
                      setFormValue({ ...formValue, lastName: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="w-full py-[14px] text-center text-white bg-[#AF8544]  flex items-center justify-center mb-[20px] md:mb-[32px]"
              >
                <p className="text-sm font-medium leading-[20px]">Continue</p>
              </button>

              <div className="text-[14px] leading-[20px] text-[#7C8493] flex j items-center mb-[13px] ">
                <p>Already have an account? &nbsp;</p>
                <Link to="/login">
                  {" "}
                  <button className="font-medium text-[#AF8544]">Login</button>
                </Link>
              </div>
            </form>
          </div>
        )}
        {stage === 2 && (
          <div className="bg-[#ffff]  w-[360px] max-w-[360px] sm:w-[480px] sm:max-w-[480px] md:w-[408px] md:max-w-[409px] mt-[74px] md:mt-[62px]  pb-[54px] my-auto ">
            <div className="relative">
              {" "}
              <button
                onClick={() => setStage(stage - 1)}
                className="absolute left-0 top-2"
              >
                {" "}
                <ArrowLeft variant="Linear" color="#25324B" size="24" />
              </button>
              <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[10px] md:mb-[20px] ">
                Account Sign up
              </h2>
            </div>
            <ProgressBar
              completed={70}
              bgColor="#AF8544"
              baseBgColor="#A8ADB7"
              isLabelVisible={false}
              height="4px"
            />

            <form
              onSubmit={() => {
                setStage(3);
              }}
              className=" w-full mt-[20px]"
            >
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Email
                </label>
                <div className=" ">
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    name="email"
                    value={formValue.email}
                    onChange={(e) => {
                      setFormValue({ ...formValue, email: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>
              {inputDisabled && (
                <div className="mb-[24px]">
                  <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                    Enter Date of Birth
                  </label>
                  <div className=" ">
                    <input
                      type="text"
                      placeholder=" 12-January-1998"
                      className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                      required
                      autoComplete="on"
                      disabled={inputDisabled}
                      name="dateOfbirth"
                      value={formValue.dob}
                      onChange={(e) => {
                        setFormValue({ ...formValue, dob: e.target.value });
                      }}
                      autoCapitalize="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                  </div>
                </div>
              )}
              {!inputDisabled && (
                <div className="mb-[24px]">
                  <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                    Enter Date of Birth
                  </label>
                  <div className=" ">
                    <input
                      type="date"
                      placeholder=" 12-January-1998"
                      className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                      required
                      autoComplete="on"
                      disabled={inputDisabled}
                      name="dateOfbirth"
                      value={formValue.dob}
                      onChange={(e) => {
                        setFormValue({ ...formValue, dob: e.target.value });
                      }}
                      max={today}
                      autoCapitalize="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                  </div>
                </div>
              )}

              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Gender
                </label>
                <div className=" ">
                  <select
                    type="text"
                    placeholder=" Enter Gender"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    disabled={inputDisabled}
                    name="gender"
                    value={formValue.gender}
                    onChange={(e) => {
                      setFormValue({ ...formValue, gender: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  >
                    <option value="">--select gender--</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Phone Number
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="Enter Phone Number"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    disabled={inputDisabled}
                    name="phoneNumber"
                    value={formValue.phone}
                    onChange={(e) => {
                      setFormValue({ ...formValue, phone: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Phone Number 2
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="Enter Phone Number"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    autoComplete="on"
                    name="phoneNumber2"
                    value={phone2}
                    onChange={(e) => {
                      setPhone2(e.target.value);
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="w-full py-[14px] mt-[24px] text-center text-white bg-[#AF8544]  flex items-center justify-center mb-[20px] md:mb-[32px]"
              >
                <p className="text-sm font-medium leading-[20px]">Continue</p>{" "}
              </button>

              <div className="text-[14px] leading-[20px] text-[#7C8493] flex  items-center mb-[54px] ">
                <p>Already have an account? &nbsp;</p>
                <Link to="/login">
                  {" "}
                  <button className="font-medium text-[#AF8544]">Login</button>
                </Link>
              </div>
            </form>
          </div>
        )}
        {stage === 3 && (
          <div className="bg-[#ffff]  w-[360px] max-w-[360px] sm:w-[480px] sm:max-w-[480px] md:w-[408px] md:max-w-[409px] mt-[74px] md:mt-[62px]  mb-[54px] my-auto ">
            <div className="relative">
              {" "}
              <button
                onClick={() => setStage(stage - 1)}
                className="absolute left-0 top-2"
              >
                {" "}
                <ArrowLeft variant="Linear" color="#25324B" size="24" />
              </button>
              <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[10px] md:mb-[20px] ">
                Account Sign up
              </h2>
            </div>
            <ProgressBar
              completed={100}
              bgColor="#AF8544"
              baseBgColor="#A8ADB7"
              isLabelVisible={false}
              height="4px"
            />

            <form
              onSubmit={(e) => {
                signUpUser(e);
              }}
              className=" w-full mt-[40px]"
            >
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Residential Address
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder=" Enter Residential Address"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    name="address"
                    value={formValue.address}
                    disabled={inputDisabled}
                    onChange={(e) => {
                      setFormValue({ ...formValue, address: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>

              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Division
                </label>
                <div className=" ">
                  <select
                    type="text"
                    placeholder=" Enter Postal Code"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    name="address"
                    value={formValue.division}
                    onChange={(e) => {
                      setFormValue({ ...formValue, division: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  >
                    <option value="">Select Division</option>
                    <option value="Badagry">Badagry</option>
                    <option value="Epe">Epe</option>
                    <option value="Ikeja">Ikeja</option>
                    <option value="Ikorodu">Ikorodu</option>
                    <option value="Lagos">Lagos</option>
                    <option value="NonIndegene">Non Indegene</option>
                  </select>
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Enter Username
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="Enter username name "
                    className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    name="username"
                    value={formValue?.userName}
                    onChange={(e) => {
                      setFormValue({ ...formValue, userName: e.target.value });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                  <p className="text-[10px] text-red-400">
                    * Username must be 6 characters
                  </p>
                </div>
              </div>
              {/* <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Account Number
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="0000 XXXX XX"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    name="account_number"
                    value={formValue?.Account_Number}
                    onChange={(e) => {
                      setFormValue({
                        ...formValue,
                        Account_Number: e.target.value,
                      });
                    }}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  />
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Bank Name
                </label>
                <div className=" ">
                  <select
                    type="text"
                    placeholder="0000 XXXX XX"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    name="bank_name"
                    value={formValue?.Bank_Name}
                    onChange={(e) => {
                      setFormValue({ ...formValue, Bank_Name: e.target.value });
                    }}
                  >
                    <option value="">-- Select Bank --</option>
                    {nigerianBanks?.map((item) => (
                      <option value={item}>{item}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Account Name
                </label>
                <div className=" ">
                  <input
                    type="text"
                    placeholder="John Doe"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    autoComplete="on"
                    name="account_name"
                    value={formValue?.Account_Name}
                    onChange={(e) => {
                      setFormValue({
                        ...formValue,
                        Account_Name: e.target.value,
                      });
                    }}
                  />
                </div>
              </div> */}

              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Upload Selfie
                </label>
                <div className=" ">
                  <input
                    type="file"
                    placeholder=" Enter course of study"
                    className="w-full h-[40px] px-[10px] py-[8px] text-[16px] text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    required
                    accept=".png, .jpg, .jpeg"
                    name="image"
                    maxs
                    onChange={(e) => {
                      file_uploader(e.target);
                    }}
                    // size={2}
                  />
                  <div className="flex items-center gap-1">
                    {isImageLoading && (
                      <ClipLoader size={11} color="#AF8544" className="" />
                    )}
                    <p className="text-[10px] text-gray-400">
                      *Maximum file size is 200kb
                    </p>
                  </div>

                  {imageError && (
                    <p className="text-[10px] text-red-400">
                      {imageErrorMessage}{" "}
                    </p>
                  )}
                </div>
              </div>

              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Password
                </label>
                <div className=" ">
                  <div className=" relative  flex items-center">
                    <div className="absolute right-[16px]">
                      {open === false ? (
                        <Eye size="16" color="#020408" onClick={toggle} />
                      ) : (
                        <EyeSlash size="16" color="#98A2B3" onClick={toggle} />
                      )}
                    </div>{" "}
                    <input
                      type={open === false ? "password" : "text"}
                      placeholder=""
                      className="w-full h-[40px] px-[16px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                      required
                      value={password}
                      onChange={(e) => {
                        handlePassword(e);
                      }}
                      autoCapitalize="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                  </div>

                  {errorMessage && (
                    <p
                      className={` ${
                        errorMessage === "Password is strong!"
                          ? "text-[green]"
                          : "text-[red]"
                      }  pt-1 pl-1 text-left text-xs`}
                    >
                      {" "}
                      {errorMessage}
                    </p>
                  )}
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
                  Confirm Password
                </label>
                <div className=" ">
                  <div className=" relative  flex items-center">
                    <div className="absolute right-[16px]">
                      {open1 === false ? (
                        <Eye size="16" color="#020408" onClick={toggle1} />
                      ) : (
                        <EyeSlash size="16" color="#98A2B3" onClick={toggle1} />
                      )}
                    </div>{" "}
                    <input
                      type={open1 === false ? "password" : "text"}
                      placeholder=""
                      className="w-full h-[40px] px-[16px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                      required
                      autoComplete="on"
                      value={confirmPassword}
                      onChange={(e) => {
                        handleConfirmPassword(e);
                      }}
                      autoCapitalize="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                  </div>

                  {confirmPasswordError && (
                    <p
                      className={` ${
                        confirmPasswordError === "Password match!"
                          ? "text-[green]"
                          : "text-[red]"
                      }  pt-1 pl-1 text-left text-xs`}
                    >
                      {" "}
                      {confirmPasswordError}
                    </p>
                  )}
                </div>
              </div>

              {/* Consent Section */}
              <div className="flex items-center space-x-2 mb-4">
                <input
                  type="checkbox"
                  id="consent"
                  required
                  checked={consentGiven}
                  onChange={(e) => setConsentGiven(e.target.checked)}
                  className="text-[#AF8544] h-4 w-4"
                />
                <label htmlFor="consent" className="text-sm">
                  By clicking the signup button you agree to the{" "}
                  <a href="#" className="text-[#AF8544] underline">
                    terms and conditions
                  </a>
                  .
                </label>
              </div>

              <button
                type="submit"
                className="w-full py-[14px] text-center text-white bg-[#AF8544]  flex items-center justify-center gap-2 mb-[20px] md:mb-[32px]"
              >
                <p className="text-sm font-medium leading-[20px]">Sign Up</p>
                {isLoading && <ClipLoader color={"white"} size={20} />}
              </button>

              <div className="text-[14px] leading-[20px] text-[#7C8493] flex j items-center pb-8 ">
                <p>Already have an account? &nbsp; </p>
                <Link to="/login">
                  {" "}
                  <button className="font-medium text-[#AF8544]">Login</button>
                </Link>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Signup;
